import { useTranslation } from "@/hooks/useTranslation";
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { HeartHandshake } from "lucide-react";

export default function PhotoResubmitModalElegant() {
  const t = useTranslation();

  return (
    <DialogContent className="dark text-white">
      <DialogHeader>
        <DialogTitle className="flex flex-row items-center text-left mb-4">
          <HeartHandshake className="h-5 w-5 mr-2" />
          {t.PHOTO_UPLOAD_ACTION_REQUIRED_ELEGANT.TITLE}
        </DialogTitle>
        <DialogDescription className="text-left text-md">
          {t.PHOTO_UPLOAD_ACTION_REQUIRED_ELEGANT.DESCRIPTION}
        </DialogDescription>
        <div className="pt-2 pb-4">
          <ul className="list-disc pl-6 space-y-2 text-left text-md text-muted-foreground">
            <li>
              {t.PHOTO_UPLOAD_ACTION_REQUIRED_ELEGANT.HIGH_QUALITY_PHOTOS}
            </li>
            <li>{t.PHOTO_UPLOAD_ACTION_REQUIRED_ELEGANT.ELEGANT_PHOTOS}</li>
          </ul>
        </div>
        <div className="text-left text-md text-muted-foreground">
          {t.PHOTO_UPLOAD_ACTION_REQUIRED_ELEGANT.HAPPY_TO_REVIEW}
        </div>
      </DialogHeader>
    </DialogContent>
  );
}
